"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
const useStyles = () => ({
  snetLogo: {
    maxWidth: "300px !important"
  }
});
exports.useStyles = useStyles;